<template>
  <v-row class="fill-height">
    <v-col @mouseleave="endDrag">
      <v-sheet height="64">
        <v-toolbar flat>
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            Hoje
          </v-btn>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Dia</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mês</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn fab text color="grey darken-2" class="ml-4" @click="prev">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <v-btn fab text color="grey darken-2" class="mr-4" @click="next">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>

          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>

          <v-spacer />

          <Feriados
            @atualizar-lista-de-feriados="buscarListaDeFeriados()"
            @verificar-datas-feriados-existente="mundanca_grupo = $event"
          />

          <MudarGrupos
            :items="mundanca_grupo"
            @atualizar-lista-de-feriados="listar()"
          />

          <SysDialog
            v-model="dialog"
            max-width="600px"
            :titulo="title"
            content-class="evento-item"
            @click:primary="salvar"
            @click:hidden-dialog="fechar"
          >
            <template #ativador>
              <v-btn color="primary" dark @click="dialog = true">
                <v-icon left>mdi-plus</v-icon>
                Novo
              </v-btn>
            </template>

          <v-row class="ma-0 pa-0">
            <v-col :cols="col1" class="pa-0 ma-0">
              <v-autocomplete
                v-model="form.id_grupo_sep"
                :items="select.options.gruposeparacao"
                label="Escolha o Grupo de Separação*"
                clearable
                outlined
                item-text="descricao"
                item-value="id"
                :multiple="parseInt(form.recorrencia) === 5"
                :error-messages="errorGrupoSeparacao"
                @input="$v.form.id_grupo_sep.$touch()"
                @blur="$v.form.id_grupo_sep.$touch()"
              >
              </v-autocomplete>

              <v-autocomplete
                v-model="form.recorrencia"
                :items="select.options.recorrencia"
                label="Escolha a Recorrência*"
                clearable
                outlined
                item-text="descricao"
                item-value="id"
                v-on:change="changeRecorrencia"
                :error-messages="errorRecorrencia"
                @input="$v.form.recorrencia.$touch()"
                @blur="$v.form.recorrencia.$touch()"
              >
              </v-autocomplete>

              <v-menu
                v-model="dpmDataInicial"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.data_inicial"
                    :label="'Data Inicial*'"
                    outlined
                    v-mask="maskData"
                    persistent-hint
                    v-bind="attrs"
                    v-on="on"
                    @focus="$event.target.select()"
                    :error-messages="errorDataInicial"
                    @input="$v.form.data_inicial.$touch()"
                    @blur="$v.form.data_inicial.$touch()"
                    append-icon="mdi-calendar"
                    @click:append="dpmDataInicial = true"
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="dp.data_inicial"
                  no-title
                  :min="today"
                  :allowed-dates="disabilitarFeriados"
                ></v-date-picker>
              </v-menu>

              <v-menu
                v-model="dpmDataFinal"
                transition="scale-transition"
                v-if="habilitaFiltro.data_final"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.data_final"
                    :label="'Data Final*'"
                    outlined
                    v-mask="maskData"
                    persistent-hint
                    v-bind="attrs"
                    v-on="on"
                    @focus="$event.target.select()"
                    :error-messages="errorDataFinal"
                    @input="$v.form.data_final.$touch()"
                    @blur="$v.form.data_final.$touch()"
                    append-icon="mdi-calendar"
                    @click:append="dpmDataFinal = true"
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="dp.data_final"
                  no-title
                  :min="today"
                  :allowed-dates="disabilitarFeriados"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col v-if="habilitaFiltro.dia_semana" cols="5" class="ma-0 pa-0 pl-3">
              <div class="pt-2" style="border: 1px solid #9e9e9e;border-radius: 5px;height: 325px;">
                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="form.dia_semana"
                  label="Domingo"
                  value="1"
                  :error-messages="errorDiaSemana"
                  @input="$v.form.dia_semana.$touch()"
                  @blur="$v.form.dia_semana.$touch()"
                ></v-checkbox>

                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="form.dia_semana"
                  label="Segunda-feira"
                  value="2"
                  :error-messages="errorDiaSemana"
                  @input="$v.form.dia_semana.$touch()"
                  @blur="$v.form.dia_semana.$touch()"
                ></v-checkbox>

                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="form.dia_semana"
                  label="Terça-feira"
                  value="3"
                  :error-messages="errorDiaSemana"
                  @input="$v.form.dia_semana.$touch()"
                  @blur="$v.form.dia_semana.$touch()"
                ></v-checkbox>

                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="form.dia_semana"
                  label="Quarta-feira"
                  value="4"
                  :error-messages="errorDiaSemana"
                  @input="$v.form.dia_semana.$touch()"
                  @blur="$v.form.dia_semana.$touch()"
                ></v-checkbox>

                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="form.dia_semana"
                  label="Quinta-feira"
                  value="5"
                  :error-messages="errorDiaSemana"
                  @input="$v.form.dia_semana.$touch()"
                  @blur="$v.form.dia_semana.$touch()"
                ></v-checkbox>

                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="form.dia_semana"
                  label="Sexta-feira"
                  value="6"
                  :error-messages="errorDiaSemana"
                  @input="$v.form.dia_semana.$touch()"
                  @blur="$v.form.dia_semana.$touch()"
                ></v-checkbox>

                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="form.dia_semana"
                  label="Sabado"
                  value="7"
                  :error-messages="errorDiaSemana"
                  @input="$v.form.dia_semana.$touch()"
                  @blur="$v.form.dia_semana.$touch()"
                ></v-checkbox>
              </div>
            </v-col>
          </v-row>
          </SysDialog>
        </v-toolbar>
      </v-sheet>

      <v-sheet>
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          :interval-count="0"
          :interval-width="18"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @mousemove:day="moveDrag"
          @mouseup:day="endDrag"
        >
          <template v-slot:event="{ event }">
            <div v-if="event.feriado" class="mt-2 text-center">
              <v-icon :size="23">mdi-calendar-remove</v-icon>
              <span class="text-gray-600 font-13 ml-1">{{event.name}}</span>
            </div>

            <div
              v-else
              class="pa-1 d-flex white"
              style="border-radius: 2px;margin: 1px 1px 0 10px !important;padding-bottom: 1px !important;user-select: none;"
              @mousedown="startDrag(event)"
            >
              <div
                class="error--text"
                v-if="event.status == 2"
                style="line-height: 27px"
              >
                {{ event.name }}
              </div>

              <div
                class="warning--text"
                v-else-if="event.status == 1"
                style="line-height: 27px"
              >
                {{ event.name }}
              </div>

              <div
                class="warning--text"
                v-else-if="event.status == 3"
                style="line-height: 27px"
              >
                {{ event.name }}
              </div>

              <div
                class="grey--text lighten-2"
                v-else
                style="line-height: 27px"
              >
                {{ event.name }}
              </div>

              <div class="ml-auto">
                <v-icon v-if="event.ativo_para_separacao" class="cursor-move">mdi-drag</v-icon>
                <v-icon color="error" v-if="event.status == 2">mdi-alert-octagon-outline</v-icon>
                <v-icon color="warning" v-else-if="event.status == 1">mdi-alert-outline</v-icon>
                <v-icon color="warning" v-else-if="event.status == 3">mdi-check-all</v-icon>
                <v-icon color="grey lighten-2" v-else>mdi-calendar-clock</v-icon>
              </div>
            </div>
          </template>
        </v-calendar>

        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark height="34">
              <v-toolbar-title>
                <h5 v-html="selectedEvent.name"></h5>
              </v-toolbar-title>

              <v-spacer />

              <v-btn v-if="selectedEvent.ativo_para_separacao" icon @click="excluirGrupoSeparacaoDoDiaCalendario">
                <v-icon>mdi-delete</v-icon>
              </v-btn>

              <v-btn icon @click="selectedOpen = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text style="min-height: 200px; background-color: white">
              <ListaHorariosQueORoboSeparou
                v-if="selectedEvent.horarios"
                :horarios="selectedEvent.horarios"
              />
              <div v-else>{{ selectedEvent.details }}</div>

              <div v-if="!selectedEvent.horarios" class="card-icon-bg">
                <v-icon color="error" v-if="selectedEvent.status == 2">mdi-alert-octagon-outline</v-icon>
                <v-icon color="warning" v-else-if="selectedEvent.status == 1">mdi-alert-outline</v-icon>
                <v-icon color="warning" v-else-if="selectedEvent.status == 3">mdi-check-all</v-icon>
                <v-icon color="grey lighten-2" v-else>mdi-calendar-clock</v-icon>
              </div>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import DrpAPI from "../../../api/drp";
import moment from "moment";
import { mask } from "vue-the-mask";
import {logout} from "@/helpers";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import Feriados from "./CalendarioSeparacaoFeriados.vue"
import ListaHorariosQueORoboSeparou from "@/components/drp/configDrpAutomatizado/CalendarioSeparacao/ListaHorariosQueORoboSeparou.vue";
import MudarGrupos from "./Feriados/MudarGrupoExitente.vue";
import { getDatasDeFeriados } from '@/api/drp';

export default {
  components: {
    ListaHorariosQueORoboSeparou,
    SysDialog,
    Feriados,
    MudarGrupos
  },
  directives: { mask },
  props: ["atualizar"],
  data: () => ({
    focus: "",
    type: "week",
    typeToLabel: {
      month: "Mês",
      week: "Semana",
      day: "Dia",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    width: "600px",
    col1: "12",
    events: [],
    select: {
      options: {
        grupoSeparacao: [],
        recorrencia: [
          { id: "1", descricao: "Unica" },
          { id: "2", descricao: "Diariamente" },
          { id: "3", descricao: "Semanalmente" },
          { id: "4", descricao: "Mesalmente" },
          { id: "5", descricao: "Alternado" },
        ],
      },
    },
    dialog: false,
    title: "Novo Calendário de Separação",
    form: {
      id_grupo_sep: "",
      recorrencia: "1",
      dia_semana: [],
      data_inicial: "",
      data_final: "",
    },
    habilitaFiltro: {
      dia_semana: false,
      data_final: false,
    },
    removeTracos: (data) => data.replaceAll("-", ""),
    maskData: {
      mask: "##/##/####",
      tokens: {
        "#": { pattern: /[0-9]/ },
      },
    },
    dp: {
      data_inicial: "",
      data_final: "",
    },
    dpmDataInicial: false,
    dpmDataFinal: false,
    item_sendo_arratado: null,
    data_inicial_item_sendo_arratado: null,
    lista_de_feriados: [],
    mundanca_grupo: []
  }),
  validations: {
    form: {
      id_grupo_sep: {
        required,
        qtdeSelecionado: function () {
          if (parseInt(this.form.recorrencia) !== 5) return true;
          return (this.form.id_grupo_sep && this.form.id_grupo_sep.length > 1);
        }
      },
      data_inicial: {
        required() {
          let today = moment().format("YYYYMMDD");
          let data = moment(this.form.data_inicial, "DD/MM/YYYY").format(
            "YYYYMMDD"
          );
          if (data.length == 8 && data > today) return true;
          else return false;
        },
      },
      data_final: {
        required() {
          if (this.habilitaFiltro.data_final) {
            let today = moment().format("YYYYMMDD");
            let data = moment(this.form.data_final, "DD/MM/YYYY").format(
              "YYYYMMDD"
            );
            if (data.length == 8 && data > today) return true;
            else return false;
          } else {
            return true;
          }
        },
      },
      recorrencia: { required },
      dia_semana: {
        required() {
          if (this.habilitaFiltro.dia_semana) {
            if (this.form.dia_semana.length) return true;
            else return false;
          } else {
            return true;
          }
        },
      },
    },
  },
  computed: {
    errorGrupoSeparacao() {
      const errors = [];
      if (!this.$v.form.id_grupo_sep.$dirty) return errors;
      !this.$v.form.id_grupo_sep.required && errors.push("O grupo de separação é obrigatório.");
      !this.$v.form.id_grupo_sep.qtdeSelecionado && errors.push("Selecione mais grupos de separação.");
      return errors;
    },
    errorRecorrencia() {
      const errors = [];
      if (!this.$v.form.recorrencia.$dirty) return errors;
      !this.$v.form.recorrencia.required &&
        errors.push("A recorrência é obrigatória.");
      return errors;
    },
    errorDataInicial() {
      const errors = [];
      if (!this.$v.form.data_inicial.$dirty) return errors;
      if (!this.$v.form.data_inicial.required)
        errors.push("A data inicial é obrigatória.");
      const A = moment(this.form.data_inicial, "DD/MM/YYYY").format("YYYYMMDD");
      const B = moment(this.form.data_final, "DD/MM/YYYY").format("YYYYMMDD");
      if (B && A > B) {
        errors.push("A data inicial não pode ser maior que a data final.");
      }
      return errors;
    },
    errorDataFinal() {
      const errors = [];
      if (this.habilitaFiltro.data_final) {
        if (!this.$v.form.data_final.$dirty) return errors;
        if (!this.$v.form.data_final.required)
          errors.push("A data final é obrigatória.");
        const A = moment(this.form.data_inicial, "DD/MM/YYYY").format(
          "YYYYMMDD"
        );
        const B = moment(this.form.data_final, "DD/MM/YYYY").format("YYYYMMDD");
        if (A > B) {
          errors.push("A data final não pode ser menor que a data inicial.");
        }
        return errors;
      }
    },
    errorDiaSemana() {
      const errors = [];
      if (this.habilitaFiltro.dia_semana) {
        if (!this.$v.form.dia_semana.$dirty) return errors;
        if (!this.$v.form.dia_semana.required)
          errors.push("O dia da semana é obrigatório.");
      }
      return errors;
    },
    today() {
      return moment().toISOString();
    },
  },
  watch: {
    atualizar() {
      if (this.atualizar == 4) {
        this.selects();
        this.listar();
      }
    },
    "dp.data_inicial"() {
      if (this.dp.data_inicial) {
        this.form.data_inicial = moment(this.dp.data_inicial).format("DD/MM/YYYY");
      }
    },
    "dp.data_final"() {
      if (this.dp.data_final) {
        this.form.data_final = moment(this.dp.data_final).format("DD/MM/YYYY");
      }
    },
    dialog(valor) {
      if (valor) this.validarDataInicial();
    },
    lista_de_feriados() {
      this.listar();
    }
  },
  created() {
    this.listar();
    this.selects();
  },
  mounted() {
    this.buscarListaDeFeriados();
    this.validarDataInicial();
  },
  methods: {
    validarDataInicial() {
      let count_days = 1;
      let pre_data = moment().add(count_days, "days").format('YYYY-MM-DD');
      let validador = this.lista_de_feriados.includes(pre_data);

      while (validador) {
        count_days++;
        pre_data = moment(pre_data).add(count_days, 'days').format('YYYY-MM-DD');
        validador = this.lista_de_feriados.includes(pre_data);
      }

      this.form.data_inicial = moment(pre_data).format("DD/MM/YYYY");
    },
    disabilitarFeriados(date) {
      return !this.lista_de_feriados.includes(date);
    },
    buscarListaDeFeriados() {
      getDatasDeFeriados().then((feriados) => this.lista_de_feriados = feriados.map(m => moment(m.data_feriado, 'DD/MM/YYYY').format('YYYY-MM-DD')));
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      if (this.lista_de_feriados.includes(event.start)) return;

      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    changeRecorrencia(e) {
      if (parseInt(e) === 5) {
        this.form.id_grupo_sep = (this.form.id_grupo_sep > 0) ? [this.form.id_grupo_sep] : [];
      } else if (Array.isArray(this.form.id_grupo_sep)) {
        this.form.id_grupo_sep = this.form.id_grupo_sep[0] || '';
      }

      this.form.dia_semana = [];
      this.width = "600px";
      this.col1 = "12";

      if (e == 3 || e == 5) {
        this.habilitaFiltro = {
          dia_semana: true,
          data_final: true,
        };
        this.width = "900px";
        this.col1 = "7";
      } else if (e == 4) {
        this.habilitaFiltro = {
          dia_semana: false,
          data_final: true,
        };
        this.form.data_final = moment(this.form.data_inicial)
          .add(12, "month")
          .format("DD/MM/YYYY");
      } else if (e == 2) {
        this.habilitaFiltro = {
          dia_semana: false,
          data_final: true,
        };
      } else {
        this.habilitaFiltro = {
          dia_semana: false,
          data_final: false,
        };
        this.form.data_final = "";
      }
    },
    adicionarFeriadosAoEvento() {
      this.lista_de_feriados.forEach(data => {
        this.events.push({
          name: 'Feriado Cadastrado',
          feriado: true,
          start: data,
          end: data,
          timed: false,
        });
      })
    },
    listar() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        idLogado: localStorage.getItem("id"),
      };

      this.$store.dispatch("loading/addRequisicao",
        DrpAPI.getCalendarioSeparacao(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            if (response.status == 200) {
              this.events = response.data.calendarioseparacao;
              this.adicionarFeriadosAoEvento();
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = this.form;

        this.$store.dispatch("loading/addRequisicao",
          DrpAPI.createCalendarioSeparacao(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.events = response.data.calendarioseparacao;
              this.adicionarFeriadosAoEvento();
              this.fechar();
            })
            .catch(logout)
        );
      }
    },
    fechar() {
      this.title = "Novo Calendário de Separação";
      this.form = {
        id_grupo_sep: "",
        recorrencia: "1",
        dia_semana: [],
        data_inicial: "",
        data_final: "",
        color: "",
      };
      this.width = "600px";
      this.col1 = "12";
      this.dialog = false;
      this.habilitaFiltro = {
        dia_semana: false,
        data_final: false,
      };
      this.dp = {
        data_inicial: "",
        data_final: "",
      };
      this.$v.$reset();
    },
    selects() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        idLogado: localStorage.getItem("id"),
      };

      this.$store.dispatch("loading/addRequisicao",
        DrpAPI.getGrupoSeparacao(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            if (response.status == 200) {
              this.select.options.gruposeparacao = response.data.gruposeparacao;
            }
          })
          .catch(logout)
      );
    },
    excluirGrupoSeparacaoDoDiaCalendario() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch("loading/addRequisicao",
        DrpAPI.excluirGrupoSeparacaoDoDiaCalendario(headers, this.selectedEvent.id)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            this.selectedOpen = false;
            this.listar();
          })
          .catch(logout)
      );
    },
    atualizarDataGrupoSeparacao(item) {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch("loading/addRequisicao",
        DrpAPI.atualizarDataGrupoSeparacao(headers, item)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
          })
          .catch(logout)
      );
    },
    startDrag(ev) {
      if (!ev.ativo_para_separacao) return;
      this.data_inicial_item_sendo_arratado = ev.start;
      this.item_sendo_arratado = ev;
    },
    moveDrag(ev) {
      if (!this.item_sendo_arratado || !(ev.future || ev.present)) return;

      if (!this.lista_de_feriados.includes(ev.date)) {
        this.item_sendo_arratado.start = ev.date;
      }
    },
    endDrag() {
      if (!this.item_sendo_arratado) return;

      if (this.data_inicial_item_sendo_arratado === this.item_sendo_arratado.start) {
        this.item_sendo_arratado = null;
        this.data_inicial_item_sendo_arratado = null;
        return;
      }

      this.atualizarDataGrupoSeparacao(this.item_sendo_arratado);
      this.item_sendo_arratado = null;
      this.data_inicial_item_sendo_arratado = null;
    },
  },
};
</script>

<style>
.v-calendar-daily_head-day-label {
  padding: 0px 0px 5px 0px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 5px;
}
.v-calendar-daily_head-day {
  border-top: 1px solid #e0e0e0 !important;
}
.theme--light.v-calendar-daily {
  border-left: 0 !important;
  border-top: 0 !important;
  border-right: 0;
  border-bottom: 0;
}

.v-calendar {
  min-height: calc(100vh - 230px) !important;
  overflow-y: auto !important;
}

.v-calendar-daily_head-day {
  min-height: calc(100vh - 230px);
  border-radius: 5px;
  padding-bottom: 4px;
}
.v-calendar-weekly__day {
  min-height: calc(100vh - 230px);
}
.v-event-start {
  margin-left: 2.5%;
  margin-bottom: 4px !important;
}

.v-calendar-daily__intervals-head::after {
  height: 0 !important;
}
.v-calendar-daily__intervals-head {
  border: 0 !important;
}
.v-calendar-daily__head .v-calendar-daily_head-day:nth-child(2) {
  border-left: #e0e0e0 1px solid !important;
}
.v-calendar-daily__head {
  overflow: auto;
}
.v-calendar-monthly {
  margin: 0 1rem;
  width: calc(100% - 2rem) !important;
}
.v-calendar.v-calendar-events .v-calendar-weekly__day {
  margin-right: 0px !important;
}
.v-calendar-weekly {
  border-top: 0 !important;
  border-radius: 4px;
}
.v-calendar-weekly__day {
  border-top: #e0e0e0 1px solid !important;
  border-radius: 4px !important;
}
.v-calendar-weekly {
  display: flex !important;
  -webkit-box-orient: initial !important;
  -webkit-box-direction: initial !important;
  flex-direction: initial !important;
}
.v-calendar-weekly__day.v-future.v-outside,
.v-calendar-weekly__day.v-past.v-outside,
.v-calendar-weekly__day.v-present.v-outside,
.v-calendar-weekly__head-weekday.v-past,
.v-calendar-weekly__head-weekday.v-present,
.v-calendar-weekly__head-weekday.v-future {
  display: none;
}
.v-calendar-weekly__week {
  display: contents !important;
}
.v-calendar-weekly__day {
  flex: 1 1 auto !important;
}

.v-btn--fab.v-size--small {
  height: 25px !important;
  width: 25px !important;
}
.v-btn--fab.v-size--default {
  height: 40px !important;
  width: 40px !important;
}
.v-event.v-event-start.v-event-end {
  height: 34px !important;
}

.card-icon-bg {
  transition: all 0.3s linear;
  position: absolute;
  bottom: 15px;
  right: 15px;
  z-index: 0;
  font-size: 90px;
  color: rgba(0, 0, 0, 0.15);
}

.card-icon-bg i {
  font-size: 90px !important;
}
</style>
